import React from 'react';

const SelectableAreaContext = React.createContext({
  selectable: {
    register: () => {},
    unregister: () => {},
    setDisableSelection: () => {},
    disableSelectionOnHover: false,
  },
});

export default SelectableAreaContext;
